import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getVisitors, removeVisitor } from '../../slice/visitorSlice';
import AdminTable from 'common/AdminTable';
import TruncatedMessage from 'common/TruncatedMessage';

const VisitorList = () => {
    const dispatch = useDispatch();
    const visitorData = useSelector((state) => state.visitors);
    
    const tableHeaders = [
        {
            Header: 'ID',
            accessor: 'id',
        },
        {
            Header: 'Name',
            accessor: 'name',
        },
        {
            Header: 'Mobile',
            accessor: 'mobileNumber',
        },
        {
            Header: 'Type',
            accessor: 'visitorType',
        },
        {
            Header: 'Occupation',
            accessor: 'occupation',
        },
        {
            Header: 'Purpose',
            accessor: 'purpose',
            Cell: ({ row }) => <TruncatedMessage text={row.original.purpose || ''} maxLength={20} />
        },
        {
            Header: 'Actions',
            accessor: 'actions',
            Cell: ({ row }) => (
                <button
                    className="btn removebtn"
                    onClick={() => dispatch(removeVisitor(row.original.id))}
                >
                    Remove
                </button>
            ),
        },
    ];

    useEffect(() => {
        dispatch(getVisitors());
    }, [dispatch]);

    return (
        <>
            <div className="container-fluid mt-4">
                {/* Premium Animated Header Banner */}
                <div 
                    className="dashboard-header-card d-flex align-items-center justify-content-between mb-4 mx-2 shadow-lg" 
                    style={{ 
                        background: 'linear-gradient(135deg, #0d47a1 0%, #00695c 100%)', 
                        padding: '1.5rem 2rem', 
                        borderRadius: '15px',
                        animation: 'fadeInUp 0.6s ease-out forwards'
                    }}
                >
                    <div className="d-flex align-items-center">
                        <div className="icon-circle mr-3" style={{ background: 'rgba(255,255,255,0.2)', width: '50px', height: '50px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <i className="fa fa-qrcode text-white" style={{ fontSize: '24px' }}></i>
                        </div>
                        <div>
                            <h3 className="text-white font-weight-bold mb-0" style={{ letterSpacing: '0.5px' }}>QR Visitors</h3>
                            <p className="text-white-50 mb-0 small">Review and manage visitors who scanned the QR code</p>
                        </div>
                    </div>
                </div>
                {/* Conditionally render AdminTable */}
                {visitorData?.data?.length > 0 ? (
                    <AdminTable tableHeaders={tableHeaders} tableData={visitorData.data} />
                ) : (
                    <div className="text-center mt-5">
                        <p>No visitors found.</p>
                    </div>
                )}
            </div>
        </>
    );
};

export default VisitorList;
